module.exports = __webpack_public_path__ + "static/media/discover_img.f5d64531.png";